import * as React from "react"
import {Box} from "@mui/material";
import {formatNumber} from "@ui-seeker/utils";

import {ArrowBackground} from "@components";
import {formatMinAge} from "@utils";


export default function numberColumn(name, label, visibility, decimals=0) {
	return [{
		name, label,
		options: {
			filter: false,
			display: visibility,
			setCellHeaderProps: () => ({ sx: {
					whiteSpace: 'pre-wrap',
					minWidth: 160
				}}),
			customBodyRowRender: (value, dataRow) => {
				const check = dataRow[`${name}_kpi`]

				let backgroundColor = 'divider'

				if (check !== null)
					backgroundColor = check ? 'success.lighter'  : 'error.lighter'

				// Item Highlights only exists on Amazon. Off Amazon the kpi is null and
				// subtitle_length arrives as 0, so show a dash instead of a misleading zero.
				const isHighlightOffAmazon = name === 'highlight' && check === null

				return <Box sx={{ textAlign: 'center', fontSize: 14 }}>
					<ArrowBackground value={value} backgroundColor={backgroundColor}>
						{value === null && '--'}
						{value !== null && isHighlightOffAmazon && '--'}
						{value !== null && !isHighlightOffAmazon && (name === 'min_age' ? formatMinAge(value) : formatNumber(value, {decimals: decimals}))}
					</ArrowBackground>
				</Box>
			}
		}
	},
	{
		name, label,
		options: {
			display: 'excluded',
			customBodyRowRender: (_, dataRow) => {
				const check = dataRow[`${name}_kpi`]
				if (check === null)
					return name === 'highlight' ? '--' : 'N/A'
				return check ? 'Yes' : 'No'
			}
		}
	}]
}